<div class="application-page page">
  <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
  <div class="heading-wrapper">
    <h4>{{ 'pages.createInfoRequest.title' | translate }}</h4>
    <div class="actions">
      <button class="primary" (click)="createApplication()">
        {{ 'pages.createInfoRequest.create' | translate }}
      </button>
    </div>
  </div>
  <div class="section">
    <app-tabs [tabs]="tabs" [activeTab]="activeTab" (tabChange)="setActiveTab($any($event))"></app-tabs>
    <form [formGroup]="form">
      <div class="lna-row no-margin">
        <div class="value-wrapper">
          <div class="label-wrapper">
            <p class="form-label">
              {{ 'pages.createInfoRequest.clientId' | translate }}
            </p>
            <app-tooltip text="clientId" [marginBottom]="false"/>
          </div>
          <app-search-client-input
            [invalid]="this.shouldRenderError('clientId')"
            [clientType]="activeTab === 'jp' ? 2 : 1"
            (clientSelected)="onClientSelected($event)"
          />
          @if (getErrorMessage('clientId'); as errorMessage) {
            <div class="error-wrapper">
              <small class="error-message">
                {{ errorMessage | translate }}
              </small>
            </div>
          }
        </div>
      </div>
    </form>
  </div>
  @if (selectedClient) {
    <div class="section client-info">
      <div class="heading-wrapper">
        <h4>
          {{ 'pages.createInfoRequest.clientInfoTitle' | translate }}
        </h4>
      </div>
      @if (activeTab === 'fp') {
        <div class="lna-row">
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.general.name' | translate }}
            </p>
            <p class="form-value">{{ getFirstName() }}</p>
          </div>
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.general.surname' | translate }}
            </p>
            <p class="form-value">{{ getLastName() }}</p>
          </div>
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.general.status' | translate }}
            </p>
            <p class="form-value">
              {{ 'pages.client.FrontofficeReadingRoomSubmissionStatus.' + selectedClient.status | translate }}
            </p>
          </div>
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.general.email' | translate }}
            </p>
            <p class="form-value">{{ selectedClient.email || '-' }}</p>
          </div>
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.general.country' | translate }}
            </p>
            <p class="form-value">{{ selectedClient.country?.name || '-' }}</p>
          </div>
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.general.officialDocumentId' | translate }}
            </p>
            <p class="form-value">{{ selectedClient.officialDocumentId || '-' }}</p>
          </div>
        </div>
        <div class="lna-row">
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.general.nationalDigitalId' | translate }}
            </p>
            <p class="form-value">{{ selectedClient.nationalDigitalId ?? '-' }}</p>
          </div>
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.general.phone' | translate }}
            </p>
            <p class="form-value">{{ selectedClient.phone || '-' }}</p>
          </div>
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.general.authType' | translate }}
            </p>
            <p class="form-value">
              {{ getAuthenticationTypeName(selectedClient.authenticationType) }}
            </p>
          </div>
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.general.address' | translate }}
            </p>
            <p class="form-value">{{ selectedClient.address || '-' }}</p>
          </div>
        </div>
      } @else {
        <div class="lna-row">
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.organization.name' | translate }}
            </p>
            <p class="form-value">{{ selectedClient.legalEntityName || selectedClient.fullName || '-' }}</p>
          </div>
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.organization.registrationNumber' | translate }}
            </p>
            <p class="form-value">{{ selectedClient.nationalDigitalId ?? '-' }}</p>
          </div>
          <div class="value-wrapper">
            <p class="form-label">
              {{ 'pages.client.general.authType' | translate }}
            </p>
            <p class="form-value">
              {{ getAuthenticationTypeName(selectedClient.authenticationType) }}
            </p>
          </div>
        </div>
      }
    </div>
  }
</div>
